export default __webpack_public_path__ + "static/media/flyte-1-1.1c6b4c58.svg";